export const ENV_GOV_TYPES = ['il2', 'il4'];
export const ENV_TYPES = ['commercial', ...ENV_GOV_TYPES];
export function isGovEnvType(type) {
    return ENV_GOV_TYPES.includes(type);
}
//# sourceMappingURL=env-type.js.map